import React, { Component } from 'react';
import { ChartScaleViewModel, ItoDrawingViewModel, MathExt } from './ChartEngine';
import ChartDrawer, { DrawOption } from './ChartDrawer';

interface Props {
    width: number,
    height: number,
    chartScale: ChartScaleViewModel,
    itoDrawings: Array<ItoDrawingViewModel>,
    resolution: number,
    step: number,
};

class YubinukiChart extends Component<Props> {
    canvasRef: React.RefObject<HTMLCanvasElement>;
    marginHorizontal: number = 8;
    drawOption: DrawOption;

    constructor(props: Props) {
        super(props);
        this.canvasRef = React.createRef();
        this.drawOption = this.createOption(props);
    }

    componentDidMount() {
        this.updateCanvas();
    }

    componentDidUpdate() {
        this.drawOption = this.createOption(this.props);
        this.updateCanvas();
    }

    createOption(props: Props): DrawOption {
        let scaleTop = props.height * 0.23;
        let scaleBottom = props.height * 0.8;
        return {
            chartWidth: props.width - this.marginHorizontal * 2,
            scaleTop: scaleTop,
            scaleBottom: scaleBottom,
            kagariTop: scaleTop + 18,
            kagariBottom: scaleBottom - 18,
            drawScale: true,
            backgroundColor: 'white',
            resolution: props.resolution,
            step: props.step,
        }
    }

    updateCanvas() {
        const canvas = this.canvasRef.current;
        if (canvas === null) { console.warn("canvas is null."); return; }
        ChartDrawer.draw(canvas, this.props.chartScale, this.props.itoDrawings, this.drawOption);
    }

    render() {
        return <div className="yubinukiChartContainer"><canvas className="yubinukiChart" ref={this.canvasRef} width={this.props.width} height={this.props.height} /></div>;
    }
};

export default YubinukiChart;
